function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#B3B3B3;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M86,307.3c-47.4,0-86-38.6-86-86s38.6-86,86-86c23.8,0,46,9.5,62.4,26.8c3.3,3.5,3.2,9-0.3,12.3 c-3.5,3.3-9,3.2-12.3-0.3c-13.1-13.8-30.7-21.4-49.7-21.4c-37.8,0-68.6,30.8-68.6,68.6s30.8,68.6,68.6,68.6 c19,0,36.6-7.6,49.7-21.4c3.3-3.5,8.8-3.6,12.3-0.3c3.5,3.3,3.6,8.8,0.3,12.3C131.9,297.8,109.8,307.3,86,307.3z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M196.7,230.3c-3.1,0-6-1.6-7.6-4.5c-2.3-4.2-0.8-9.5,3.4-11.8l187.2-103.7c2.5-1.4,5.5-1.5,8.1-0.2 l206.9,101.7l185.9-101.5c4.2-2.3,9.5-0.8,11.8,3.5c2.3,4.2,0.8,9.5-3.5,11.8L599,229.2c-2.5,1.4-5.5,1.4-8,0.2L384.1,127.8 L200.9,229.2C199.6,230,198.1,230.3,196.7,230.3z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M848.1,152.5c-0.7,0-1.4-0.1-2.1-0.3c-4.7-1.2-7.5-5.9-6.4-10.6c4.5-18.2-0.7-38.8-13.9-55.1 c-13.2-16.3-32.3-25.6-51-25c-4.7,0.2-8.8-3.6-9-8.4c-0.2-4.8,3.6-8.8,8.4-9c24.2-0.7,48.5,10.9,65.2,31.5 c16.6,20.5,23.1,46.8,17.2,70.3C855.5,149.9,852,152.5,848.1,152.5z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M894.9,144.5c-0.5,0-1,0-1.5-0.1c-4.7-0.8-7.9-5.3-7.1-10c4.4-26.1-4.1-55.4-22.7-78.4 c-18.6-23-45.5-37.4-72-38.5c-4.8-0.2-8.5-4.3-8.3-9.1c0.2-4.8,4.3-8.4,9.1-8.3c31.8,1.4,62.7,17.8,84.8,45 c22.1,27.2,31.7,60.9,26.4,92.3C902.8,141.5,899.1,144.5,894.9,144.5z"
})))));

function SvgChemeSpherelogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 904.9 307.3",
    style: {
      enableBackground: "new 0 0 904.9 307.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChemeSpherelogo);
export default __webpack_public_path__ + "static/media/ChemeSphere logo.aa514f5d.svg";
export { ForwardRef as ReactComponent };